import api from "./api";
import * as Helpers from "@/helpers";
import store from "./../store";

export default {
  async Listar(params) {
    store.dispatch("loadingAux/habilitarLoading", true);
    const headers = Helpers.iniciarRequisicao();
    return await api
      .get("heranca", { headers, params })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        store.dispatch("loadingAux/habilitarLoading", false);
        return resp.data.itens;
      })
      .catch(() => {
        store.dispatch("loadingAux/habilitarLoading", false);
        Helpers.logout();
      });
  },
  async Salvar(params) {
    store.dispatch("loadingAux/habilitarLoading", true);
    const headers = Helpers.iniciarRequisicao();
    return await api
      .post("heranca", params, {
        headers: headers
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        store.dispatch("loadingAux/habilitarLoading", false);
        return resp.data.itens;
      })
      .catch(() => {
        store.dispatch("loadingAux/habilitarLoading", false);
        Helpers.logout();
      });
  },
  async Excluir(params) {
    store.dispatch("loadingAux/habilitarLoading", true);
    const headers = Helpers.iniciarRequisicao();
    let id = 0;
    if (!params.ids) {
      id = params.id_produto;
    }
    return await api
      .delete("heranca/" + id, {
        headers,
        data: params
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        store.dispatch("loadingAux/habilitarLoading", false);
        return resp.data.itens;
      })
      .catch(() => {
        store.dispatch("loadingAux/habilitarLoading", false);
        Helpers.logout();
      });
  }
};
